<div class="relative inline-block">
    <button
        type="button"
        (click)="toggle($event)"
        [disabled]="disabled || !!exportingFormat"
        class="inline-flex items-center justify-center gap-2 rounded-lg border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 text-sm font-semibold text-[color:var(--foreground)] shadow-sm transition hover:bg-[color:var(--hover)] disabled:opacity-60"
        aria-haspopup="menu"
        [attr.aria-expanded]="open"
    >
        <lucide-icon [name]="exportingFormat ? 'loader-2' : 'download'" class="h-4 w-4 shrink-0" [class.animate-spin]="!!exportingFormat"></lucide-icon>
        <span>{{ exportingFormat ? 'Exporting...' : 'Export Report' }}</span>
        <lucide-icon *ngIf="!exportingFormat" name="chevron-down" class="h-4 w-4 shrink-0"></lucide-icon>
    </button>

    <div
        *ngIf="open"
        role="menu"
        class="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-lg border border-[color:var(--border)] bg-[color:var(--card)] py-1 shadow-xl"
        (click)="$event.stopPropagation()"
    >
        <button type="button" role="menuitem" (click)="choose('pdf', $event)" class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-[color:var(--foreground)] hover:bg-[color:var(--hover)]">
            <lucide-icon name="file-text" class="h-4 w-4"></lucide-icon>
            PDF
        </button>
        <button type="button" role="menuitem" (click)="choose('xlsx', $event)" class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-[color:var(--foreground)] hover:bg-[color:var(--hover)]">
            <lucide-icon name="file-down" class="h-4 w-4"></lucide-icon>
            Excel
        </button>
        <button type="button" role="menuitem" (click)="choose('csv', $event)" class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-[color:var(--foreground)] hover:bg-[color:var(--hover)]">
            <lucide-icon name="file" class="h-4 w-4"></lucide-icon>
            CSV
        </button>
    </div>
</div>
